<template>
  <div :id="id" :class="['draggable', 'module-template', cssClass]" v-bind:style="{width: width, height: height}">
    <div :class="['module-template', cssClass]" v-bind:style="{width: width, height: height}">
      <!-- Module header (title and close button) -->
      <a @click="duplicateModule()" class='module-duplicate'><v-icon small>file_copy</v-icon></a>
      <a @click="editDescription()" class='module-description'><v-icon small>description</v-icon></a>
      <v-tooltip top>
        <a slot="activator" v-show="!editingName" @click="clickedTitle()" class='module-circle-anchor'>{{ truncateName() }}</a>
        <span>{{ editableName }}</span>
      </v-tooltip>
      <v-text-field ref="title" v-show="editingName" placeholder="Insert name" v-model="editableName" height="20px" hide-details v-on:blur="nameEdited()"
                    @keyup.enter="nameEdited()" v-bind:class="{'module-method-title': cssClass==='module-method',
                    'module-input-title': cssClass==='module-input'}"></v-text-field>
      <a @click="destroyModule()" class='module-close'><v-icon small>close</v-icon></a>
      <!-- Variable part of the module injected here -->
      <slot name="moduleContent"></slot>
      <!-- Module output button -->
      <button :id="id+'-output'" type='button' class='module-circle module-circle-output'></button>
      <span class='module-circle-span' style='margin-top: 26px; right: 22px'>Output</span>
    </div>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js'
export default {
  data: () => ({
    test: '',
    editableName: '',
    editingName: false
  }),
  props: {
    name: String,
    id: String,
    cssClass: String,
    width: String,
    height: String
  },
  methods: {
    truncateName() {
      if(this.cssClass==='module-method') return this.editableName.substring(0, 18);
      else return this.editableName.substring(0, 12);
    },
    clickedTitle() {
      this.editingName=true;
      this.$nextTick(() => this.$refs.title.focus());
    },
    editDescription() {
      EventBus.$emit('edit-module-description', this.id);
    },
    nameEdited() {
      this.editingName = false;
      EventBus.$emit('edit-module-name', {id: this.id, name: this.editableName});
    },
    duplicateModule() {
      EventBus.$emit('duplicate-module', this.id);
    },
    destroyModule() {
      EventBus.$emit('destroy-module', this.id);
    },
    showModal() {
      EventBus.$emit('show-modal-'+this.id, null);
    }
  },
  mounted: function () {
    this.editableName = this.name;
    EventBus.$on('destroy-module-'+this.id, mod => {
      EventBus.$off('destroy-module-'+this.id);
      if(this.$el.parentNode)
        this.$el.parentNode.removeChild(this.$el);
      this.$destroy();
    });
  }
}
</script>

<style scoped>
.module-template {
  position: absolute;
  color: black;
  border: black 1px solid;
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  cursor: move;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
}
.module-method {
  background-color: #d9d9d9;
}
.module-input {
  background-color: #b4effd;
}
.module-circle-anchor {
  color: black;
  position: relative;
  font-size: 13px;
  font-weight: bold;
  top: 1.5px;
  left: 9.5px;
}
.module-circle-anchor:hover { 
  color: #23527c;
  text-decoration: underline;
}
.module-close {
  position: absolute;
  top: 1.5px;
  right: 3px;
}
.module-description {
  position: absolute;
  top: 1.5px;
  left: 19px;
}
.module-duplicate {
  position: absolute;
  top: 1.5px;
  left: 3px;
}
.module-circle {
  position: absolute;
  width: 12px;
  height: 12px;
  border: black 1px solid;
  padding: 0;
}
.module-circle-input {
  background-color: white;
}
.module-circle-output {
  background-color: white;
  margin-top: 28px;
  right: 5px;
}
.module-endpoint-active {
  background-color: #4BB543;
}
.module-endpoint-warning {
  background-color: yellow;
}
.module-endpoint-error {
  background-color: #FF5252;
}
.module-circle-span {
  position: absolute;
  font-size: 12px;
  color: black;
}
.module-circle-span:hover {
  color: #23527c;
  text-decoration: underline;
  cursor: pointer;
}
.v-input {
  color: black;
  position: absolute;
  font-size: 13px;
  font-weight: bold;
  top: 1.5px;
  left: 41px;
}
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.module-method-title {
  width: 124px;
}
.module-input-title {
  width: 84px;
}
</style>


// WEBPACK FOOTER //
// src/components/Workspace/Methods/ModuleTemplate.vue